import React from 'react'
import styled from 'styled-components'
import mediaQuery from 'styles/mediaQuery'
import colors from 'styles/colors'
import { H1, H5 } from 'components/Titles'
import ContactFormContainer from 'components/form-components/Contact/ContactFormContainer'
import { containerDefaultStyles } from 'styles/defaults'

const Section = styled.section`
  background-color: rgba(251, 251, 254, 1);
  position: relative;
  padding: 20px 0 112px;
  font-size: 16px;
  line-height: 24px;
  ${mediaQuery.mobile} {
    font-size: 14px;
    padding: 15px 0 40px;
  }
`

const Container = styled.div`
  ${containerDefaultStyles};
  position: relative;
  color: ${colors.main};
`

const Title = styled(H1)`
  text-align: center;
  margin-bottom: 14px;
  font-size: 36px;
  font-weight: 700;
  line-height: 1.3;
`

const Subtitle = styled(H5)`
  text-align: center;
  font-weight: 400;
  color: #43464d;
  font-size: 18px;
  line-height: 1.3;
`

const translations = {
  header: 'Get in touch',
  subheader: 'Fill out the form below and we will get back to you shortly.',
  fullNameLabel: 'Full Name',
  fullNamePlaceholder: 'Enter Your Name',
  emailLabel: 'Email',
  emailPlaceholder: 'Enter your email address',
  reasonLabel: 'Reason',
  reasonPlaceholder: 'Select from the drop down menu',
  subjectLabel: 'Subject',
  subjectPlaceholder: 'Enter your subject',
  messageLabel: 'Message',
  messagePlaceholder: 'Enter your message here',
  uploadLabel: 'Upload attachment',
  uploadPlaceholder:
    'Drag here to upload your attachment. Allowed up to 2MB PNG,  JPG, JPEG. ',
  submitButton: 'Submit message',
}

const ContactFormSection = () => (
  <Section>
    <Container>
      <Title>{translations.header}</Title>
      <Subtitle>{translations.subheader}</Subtitle>
      <ContactFormContainer />
    </Container>
  </Section>
)

export default ContactFormSection
